import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DEFAULT_TEMPLATE_KEY, SECTIONS_LAYOUT_KEY } from '@capital-access/common/utils';
import { TemplateLibraryService } from '@capital-access/reporting/common';
import { removeLocalStorage } from '@capital-access/reporting/common';
import { DEFAULT_LAYOUT, ProfileReportLayout } from '../../profile/models/profile-report-sections';
import { saveReportLayoutSettings } from '../+state/report.actions';
import { getSavedLayout } from './section-settings.utils';

//  * Checks if the default template exists If not, dispatches actions to reset layout and remove localStorage.
export function getValidConfigurableLayout(
  store: Store,
  templateService: TemplateLibraryService,
  profileType: string
): Observable<ProfileReportLayout> {
  const layout = getSavedLayout(profileType, DEFAULT_LAYOUT) ?? DEFAULT_LAYOUT;
  if (layout === ProfileReportLayout.Configurable) {
    const defaultTemplateId = Number(localStorage.getItem(`${profileType}_${DEFAULT_TEMPLATE_KEY}`.toUpperCase()) ?? 0);
    if (defaultTemplateId > 0) {
      return templateService.getTemplates().pipe(
        map(templates => {
          if (!templates.some(t => t.templateId === defaultTemplateId)) {
            store.dispatch(
              saveReportLayoutSettings({
                key: `${profileType}_${SECTIONS_LAYOUT_KEY}`.toUpperCase(),
                layout: DEFAULT_LAYOUT
              })
            );
            store.dispatch(
              removeLocalStorage({
                keys: [`${profileType}_${DEFAULT_TEMPLATE_KEY}`.toUpperCase()]
              })
            );
            return DEFAULT_LAYOUT as ProfileReportLayout;
          }
          return layout;
        })
      );
    }
  }
  return of(layout);
}
